import { cloneElement, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { AnalyticsService } from "@/services/analytics.js"
import { toast } from "sonner"
import { handleError } from "@/services/errorHandler.js"
import * as API from "@/services/api.js"
import { MainLoader } from "@/components/loader/MainLoader.jsx"
import { AUTH_BASE_PATH } from "@/consts/index.js"

export const PublicBoardDataProvider = ({ children }) => {
    const { boardId } = useParams()
    const navigate = useNavigate()
    const [board, setBoard] = useState(null)
    const [externalAds, setExternalAds] = useState(null)
    const [advertisers, setAdvertisers] = useState(null)

    const fetchData = async () => {
        try {
            const { data } = await API.getPublicBoardById(boardId)
            if (!data) {
                toast.error("Board not found")
                navigate("/")
                return
            }
            const boardData = data.board || data
            const externalAdIds = data.externalAds || boardData.externalAds || []
            let adsData = []
            if (externalAdIds.length) {
                const adsResponse = await API.getManyExternalAdsById(externalAdIds)
                adsData = adsResponse.data || []
            }
            setBoard(boardData)
            setExternalAds(adsData)
            setAdvertisers(data.advertisers || [])
        } catch (e) {
            toast.error(e.message)
            console.log(e)
            handleError(e)
            navigate(AUTH_BASE_PATH)
        }
    }

    useEffect(() => {
        AnalyticsService.page("public-board-page", { boardId })
        if (boardId) {
            fetchData()
            return
        }
        navigate("/")
    }, [])

    const isLoading = board === null || externalAds === null || advertisers === null

    return (
        isLoading
            ? <MainLoader className="absolute w-full h-full z-10 bg-hero-background" />
            : cloneElement(children, { board, externalAds, advertisers })
    )
}
